<script>
import Price from '@wielink-application/shared/vue/components/form/input-only/price.vue'

export default Price;
</script>